import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { TopicCreateForm } from "./components/TopicCreateForm";

export function NewTopicPage() {
  return (
    <Page title="New Topic">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <TopicCreateForm />
      </Container>
    </Page>
  );
}
